import React from 'react';

export const NoTrack = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 88.4 88.4" {...props}>
      <g opacity={0.5}>
        <circle
          cx={44.2}
          cy={44.2}
          r={43.5}
          fill="#fff"
          stroke="#233762"
          strokeWidth={1.449}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={10}
        />
        <path
          d="M44.2 72.4c-15.5 0-28.1-12.6-28.1-28.1 0-15.5 12.6-28.1 28.1-28.1 15.5 0 28.1 12.6 28.1 28.1.1 15.4-12.6 28.1-28.1 28.1z"
          fill="#fff"
        />
        <path
          d="M44.2 18.1c14.4 0 26.1 11.7 26.1 26.1S58.6 70.4 44.2 70.4c-14.4 0-26.1-11.7-26.1-26.1s11.7-26.2 26.1-26.2m0-4c-16.6 0-30.1 13.5-30.1 30.1s13.5 30.1 30.1 30.1 30.1-13.5 30.1-30.1c.1-16.6-13.4-30.1-30.1-30.1z"
          fill="#233762"
        />
        <path
          fill="#fff"
          stroke="#233762"
          strokeWidth={4}
          strokeLinejoin="round"
          strokeMiterlimit={10}
          d="M22.9 65.5l42.6-42.6"
        />
      </g>
    </svg>
  );
};
